import cn from 'classnames'
import React, { ComponentProps, ReactElement } from 'react'

import style from './ContentCard.style'

type ContentCardProps = {
  className?: string
  variant?: 'standard' | 'darkened'
} & ComponentProps<'div'>

/**
 * A plain box panel that takes in children.
 * @param props
 * @returns
 */
function ContentCard(props: ContentCardProps): ReactElement {
  const { className = '', children, variant = 'standard', ...rest } = props

  return (
    <div
      className={cn('ContentCard', variant, className)}
      css={style}
      {...rest}
    >
      {children}
    </div>
  )
}

export default ContentCard
